import { toast } from 'react-toastify';

export const forceLogout = (reason = 'Invalid token. Please login again.') => {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
  } catch (e) {
    // ignore storage errors
  }
  try {
    toast.dismiss();
    if (reason) {
      toast.error(reason);
    }
  } catch (e) {
    // toast might not be initialized yet
  }
  if (typeof window !== 'undefined') {
    const loginPath = '/auth/login';
    if (window.location.pathname !== loginPath) {
      window.location.assign(loginPath);
    }
  }
};